<template>
  <div class="box">
    <img class="logo" src="../../assets/images/fkjz/logo.png" alt="">
    <img class="hb" src="../../assets/images/fkjz/海报.png" alt="">
    <div class="bm">
      <div class="user">
        <span>您的姓名:*</span>
        <input type="text" placeholder="请输入您的姓名" v-model="data.user">
      </div>
      <div class="xq">
        <span>您的小区:*</span>
        <input type="text" placeholder="请输入小区名称" v-model="data.xq">
      </div>
      <div class="submit">
        <div @click='getQY("未签约")' :class="[data.qy=='未签约'?'wqy':'yqy']">
          未签约
        </div>
        <div @click='getQY("已签约")' :class="[data.qy=='已签约'?'wqy':'yqy']">
          已签约
        </div>
      </div>
    </div>
    <div class="scimg">
      <img src="../../assets/images/fkjz/晒图.png" alt="">
      <div class="upimg">
        <van-uploader v-model="fileList" :after-read="onRead" :before-delete="afterDelete" multiple = "true"/>
      </div>
      <!-- <van-uploader v-model="fileList" :after-read="onRead" multiple/> -->
    </div>
    <div class="xz">
      <img src="../../assets/images/fkjz/选择.png" alt="">
      <div class="xznr">
        <span v-for="(item,index) in data.xx" :key="index" @click='fn(index, item.text)' :class="index == data.isactive?'background_color':''">{{ item.text }}</span>
      </div>
      <div class="submit" @click="tz()">
        提交
      </div>
    </div>
    <div class="an" @click="an()"></div>
  </div>
</template>

<script src="http://res2.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
  import axios from "axios";
  import Vue from "vue";
  import { Uploader } from 'vant';
  import { isWeixin } from "@utils/index";
  import { getUserInfo } from "@api/user";
  import { wechatEvevt } from "@libs/wechat";
  Vue.use(Uploader);
  // import { postImage } from "@api/fkjz";
  export default {
    name: "FkjzIndex",
    data () {
      return {
        data: {
          user: '',
          xq: '',
          qy: '未签约',
          isactive: -1,
          uid: 2417,
          fileList: [],
          xx: [
            { text: '品牌' },
            { text: '颜值' },
            { text: '设计' },
            { text: '环保' },
            { text: '工艺' },
            { text: '价格' }
          ],
          id: 1,
          dele: '',
          updateimg: []
        }
      }
    },

    created() {
      console.log(this.$store.state.app.token)
      console.log(this.$store.state.app.uid)
      this.data.uid = this.$store.state.app.uid
      console.log(window.location.href)
      this.setOpenShare()
    },

    methods: {
      setOpenShare: function() {
      var data = this.storeInfo;
      var href = location.href;
      if (isWeixin()) {
        if (this.isLogin) {
          getUserInfo().then(res => {
            href =
              href.indexOf("?") === -1
                ? href + "?spread=" + res.data.uid
                : href + "&spread=" + res.data.uid;
            var configAppMessage = {
              // desc: data.store_info,
              // title: '梵客家装狂欢惠',
              // link: href,
              // imgUrl: data.image,
              title: '梵客家装狂欢惠',
              link: window.location.href,
              desc: '#逛了一星期的家装公司，终于定下来了，价格惠民的梵客家装，期待帮我的家焕然一新#',
              imgUrl: 'http://yp.fkjz.cn/uploads/wechat/logo.jpg',
            };
            wechatEvevt(
              ["updateAppMessageShareData", "updateTimelineShareData"],
              configAppMessage
            )
              .then(res => {
                console.log(res);
              })
              .catch(res => {
                console.log(res);
                if (res.is_ready) {
                  res.wx.updateAppMessageShareData(configAppMessage);
                  res.wx.updateTimelineShareData(configAppMessage);
                }
              });
          });
        } else {
          var configAppMessage = {
            // desc: data.store_info,
            // title: '梵客家装狂欢惠',
            // link: href,
            // imgUrl: data.image,
            title: '梵客家装狂欢惠',
            link: window.location.href,
            desc: '#逛了一星期的家装公司，终于定下来了，价格惠民的梵客家装，期待帮我的家焕然一新#',
            imgUrl: 'http://yp.fkjz.cn/uploads/wechat/logo.jpg',
          };
          wechatEvevt(
            ["updateAppMessageShareData", "updateTimelineShareData"],
            configAppMessage
          )
            .then(res => {
              console.log(res);
            })
            .catch(res => {
              console.log(res);
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
              }
            });
        }
      }
    },

      onRead(file) {
        console.log(file.content)
        if (file.content == undefined) {
          file.forEach(item =>{
            console.log(item.content.replace(/^data:image\/\w+;base64,/, ''))
            this.data.updateimg.push(item.content.replace(/^data:image\/\w+;base64,/, ''))
            // this.data.updateimg.push(item.content)
          })
        } else {
          this.data.updateimg.push(file.content.replace(/^data:image\/\w+;base64,/, ''))
        }
        var that = this
        axios({
          method: 'post',
          url: 'https://yp.fkjz.cn/api/upload/images',
          data: {
            // filename: file.content.replace(/^data:image\/\w+;base64,/, '')
            filename: that.data.updateimg
          },
          dataType: "json"
        })
        .then(res => {
          console.log(res.data.data.url)
          this.data.fileList = res.data.data.url
          this.an()
        })
        .catch(err => {
          this.$dialog.error(err.msg || "上传失败");
        });
      },

      afterDelete(file) {
        console.log(file)
        this.isloadImg = true;
        var arr1 = this.data.updateimg
        var arr2 = []
        arr2.push(file.content.replace(/^data:image\/\w+;base64,/, ''))
        console.log(arr2)
        var set = arr2
        console.log(set)
        this.data.updateimg = arr1.filter(item=>!set.includes(item))
        console.log(this.data.updateimg)
        var that = this
        axios({
          method: 'post',
          url: 'https://yp.fkjz.cn/api/upload/images',
          data: {
            // filename: file.content.replace(/^data:image\/\w+;base64,/, '')
            filename: that.data.updateimg
          },
          dataType: "json"
        })
        .then(res => {
          console.log(res.data.data.url)
          this.data.fileList = res.data.data.url
          console.log(this.data.fileList)
          this.an()
        })
        .catch(err => {
          this.$dialog.error(err.msg || "上传失败");
        });
        return new Promise((resolve, reject) => {
          this.data.dele = "删除文件的回调,afterDelete"
	        this.isloadImg = false;
          resolve();
          var that = this
          setTimeout(function(){that.dele()},200);
        });
      },

      an() {
        if (this.data.qy == '未签约') {
          this.data.qy = '已签约'
          this.data.qy = '未签约'
        } else {
          this.data.qy = '未签约'
          this.data.qy = '已签约'
        }
      },

      dele() {
        if (this.data.dele = "删除文件的回调,afterDelete") {
          console.log('dele')
          if (this.data.qy == '未签约') {
            this.data.qy = '已签约'
            this.data.qy = '未签约'
          } else {
            this.data.qy = '未签约'
            this.data.qy = '已签约'
          }
        }
      },

      fn:function(index, value){
        console.log(index);
        console.log(value);
        this.data.isactive=index;
        console.log(this.data.isactive)
      },

      getQY(qa){
        console.log(qa);
        this.data.qy = qa
      },
      tz () {
        axios({
          method: 'post',
          url: 'https://yp.fkjz.cn/api/wechat/userinfo',
          data: {
            name: this.data.user,
            village: this.data.xq,
            uid: this.data.uid,
            qianyue: this.data.qy,
            // imageone: this.data.fileList,
            image: this.data.fileList
          }
        })
        .then(res => {
          console.log(res.data)
          if (this.data.qy == "未签约") {
            this.$router.push({
              path:'/fkjz/fkjz_wqy',
              query: {
                uid:this.data.uid,
                // xx: res.data
              }
            })
          } else {
            this.$router.push({
              path:'/fkjz/fkjz_yqy',
              query: {
                uid:this.data.uid,
                // xx: res.data
              }
            })
          }
        })
        .catch(err => {
          this.$dialog.error(err.msg || "上传失败");
        });
      }
    }
  }
</script>

<style scoped>
  .van-uploader__preview-image {
    width: 1.5rem !important;
    height: 1.5rem !important;
  }

  .background_color {
    background: -moz-linear-gradient(top, #a400e8 0%, #a400e8 100%) !important;
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#a400e8), color-stop(100%,#a400e8)) !important;
    background: -webkit-linear-gradient(top, #a400e8 0%,#a400e8 100%) !important;
    background: -o-linear-gradient(top, #a400e8 0%,#a400e8 100%) !important;
    background: -ms-linear-gradient(top, #a400e8 0%,#a400e8 100%) !important;
    background: linear-gradient(to bottom, #a400e8 0%,#a400e8 100%) !important;
  }

  .box {
    width: 100%;
    height: 100%;
    background: url("../../assets/images/fkjz/图层 13.png") 100% 100% no-repeat;
    background-size: 100% 100%;
  }
  .logo {
    padding-top: 5%;
    padding-left: 7.5%;
    width: 50%;
  }
  .hb {
    padding-top: 6%;
    display: block;
    margin: 0 auto;
    width: 80%;
  }

  .bm {
    width: 100%;
    height: 30%;
  }

  .bm .user, .bm .xq {
    width: 85%;
    height: 28%;
    margin: 0 auto;
    border-radius: 5px;
    background: #4600a9;
    margin-top: 5%;
    box-shadow: #4600a9;
    padding: 0 5%;
    border: #702bde 0.5px solid;
  }

  .bm div input {
    height: 100%;
    line-height: 100%;
    padding-left: 5%;
    color: #f6f6f6;
  }

  .bm div input::-moz-placeholde {
    color: #6700f0;
  }

  .bm div input::-ms-input-placeholder  {
    color: #6700f0;
  }
  
  .bm div input::-webkit-input-placeholder {
    color: #6700f0;
  }

  .bm div span {
    color: #6700f0;
  }

  .bm .submit {
    height: 17%;
    text-align: center;
  }

  .bm .submit div {
    width: 30%;
    height: 100%;
    line-height: 230%;
    text-align: center;
    padding-left: 0 !important;
    margin: 5%;
    border-radius: 5px;
    display: inline-block;
    color: #fff;
  }

  .bm .submit .wqy {
    background: url("../../assets/images/fkjz/矩形 10.png");
    background-size: 100% 100%;
  }

  .bm .submit .yqy {
    background: url("../../assets/images/fkjz/矩形 11.png");
    background-size: 100% 100%;
  }

  .scimg {
    width: 85%;
    height: 21%;
    overflow: hidden;
    margin: 0 auto;
    /* margin-top: 5%; */
  }

  .scimg .upimg {
    width: 100%;
    height: 97px;
    overflow: hidden;
    padding-top: 9px;
    box-sizing: border-box;
  }

  /* .van-uploader__preview-image {
    margin-top: 9px;
  } */

  .scimg img {
    width: 50%;
    margin-right: 49%;
    margin-bottom: 0.2rem;
  }

  .xz {
    width: 85%;
    margin: 0 auto;
    margin-top: 1rem;
    padding-bottom: 0.5rem;
  }

  .xz img {
    width: 50%;
  }

  .xz .xznr {
    margin-bottom: 5%;
  }

  .xz .xznr span {
    display: inline-block;
    width: 23%;
    height: 0.5rem;
    margin-right: 15%;
    text-align: center;
    margin-top: 5%;
    border-radius: 3px;
    border: #f16633 1px solid;
    /* background: linear-gradient(to bottom, #fed659, #fb879b); -webkit-background-clip: text; color: transparent;
     */
    background: -moz-linear-gradient(top, #fed659 0%, #fb879b 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#fed659), color-stop(100%,#fb879b));
    background: -webkit-linear-gradient(top, #fed659 0%,#fb879b 100%);
    background: -o-linear-gradient(top, #fed659 0%,#fb879b 100%);
    background: -ms-linear-gradient(top, #fed659 0%,#fb879b 100%);
    background: linear-gradient(to bottom, #fed659 0%,#fb879b 100%);
    color: #641e14;
  }

  .xz .xznr span:nth-child(3) {
    margin-right: 0;
  }

  .xz .xznr span:nth-child(6) {
    margin-right: 0;
  }

  .xz .submit {
    text-align: center;
    width: 60%;
    margin-top: 1%;
    padding: 2% 0;
    margin: 0 auto;
    background: -moz-linear-gradient(top, #fe00d3 0%, #9900eb 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#fe00d3), color-stop(100%,#9900eb));
    background: -webkit-linear-gradient(top, #fe00d3 0%,#9900eb 100%);
    background: -o-linear-gradient(top, #fe00d3 0%,#9900eb 100%);
    background: -ms-linear-gradient(top, #fe00d3 0%,#9900eb 100%);
    background: linear-gradient(to bottom, #fe00d3 0%,#9900eb 100%);
    color: #fff;
    border-radius: 5px;
  }
</style>